const initialState = {
	topTiersLoading: false,
	topTiers: [],
	topTierProductsLoading: false,
	topTierProducts: [],
	allCustomersLoading: false,
	allCustomers: [],
	updateProductLoading: false,
	updateCustomersLoading: false,
	success: false,
	updateSuccess: false,
	errors: {},
}

export default (state = initialState, action) => {
	switch (action.type){
		// ====================
		// CLEAR SUCCESS/ERRORS
		// ====================
		case 'CLEAR_TOPTIER_MESSAGES':
			return {
				...state,
				errors: {},
				success: false,
				updateSuccess: false
			}
		// ==================
		// GET TOP TIERS
		// ==================
		case 'LOAD_TOPTIER_LOADING':
			return {
				...state,
				errors: {},
				topTiersLoading: true,
				success: false
			}
		case 'LOAD_TOPTIER_ERROR':
			return {
				...state,
				topTiersLoading: false,
				errors: action.errors
			}
		case 'LOAD_TOPTIER_SUCCESS':
			return {
				...state,
				topTiersLoading: false,
				success: true,
				topTiers: action.data.top_tiers
			}
		// ==================
		// GET CUSTOMERS
		// ==================
		case 'LOAD_CUSTOMERS_LOADING':
			return {
				...state,
				errors: {},
				allCustomersLoading: true,
				success: false
			}
		case 'LOAD_CUSTOMERS_ERROR':
			return {
				...state,
				allCustomersLoading: false,
				errors: action.errors
			}
		case 'LOAD_CUSTOMERS_SUCCESS':
			return {
				...state,
				allCustomersLoading: false,
				success: true,
				allCustomers: action.data.all_customers
			}
		// ========================
		// UPDATE TOP TIER PRODUCTS
		// ========================
		case 'UPDATE_TTP_LOADING':
			return {
				...state,
				errors: {},
				updateProductLoading: true,
				updateSuccess: false
			}
		case 'UPDATE_TTP_ERROR':
			return {
				...state,
				updateProductLoading: false,
				updateSuccess: false,
				errors: action.errors
			}
		case 'UPDATE_TTP_SUCCESS':
			return {
				...state,
				updateProductLoading: false,
				updateSuccess: true,
			}
		// =========================
		// UPDATE TOP TIER CUSTOMERS
		// =========================
		case 'UPDATE_TTC_LOADING':
			return {
				...state,
				errors: {},
				updateCustomersLoading: true,
				updateSuccess: false
			}
		case 'UPDATE_TTC_ERROR':
			return {
				...state,
				updateCustomersLoading: false,
				errors: action.errors,
				updateSuccess: false
			}
		case 'UPDATE_TTC_SUCCESS':
			return {
				...state,
				updateCustomersLoading: false,
				updateSuccess: true
			}
		default:
			return state
	}
}


// WEBPACK FOOTER //
// ./src/store/reducers/topTier.js